import React from "react";
import Communications from "./Communications";

export default function index(props) {
  return <Communications {...props} />;
}
